/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
import { P as PickerColumn, d as defineCustomElement$1 } from './p-DKRQWlK2.js';

const IonPickerColumn = PickerColumn;
const defineCustomElement = defineCustomElement$1;

export { IonPickerColumn, defineCustomElement };
